import { Product } from './Product'

export class Coverage {
  public propertyId: number|null = 0
  public covered: boolean = false
  public estimatedDeliveryTime: number = 0
  public products: Product[] = []
  public terms: string[] = []
}
